import ContainedIcon from '@/components/ContainedIcon';
import MetaIconBase from '@/components/Icons/MetaIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function MetaIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Meta)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <MetaIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Meta),
        }}
      />
    </ContainedIcon>
  );
}

export default MetaIcon;
